import { ChevronLeft } from "lucide-react";

interface BreadcrumbsProps {
  title?: string;
  rightElement?: React.ReactNode;
  onClick: () => void;
  bg?: string;
}

export default function Breadcrumbs({
  title,
  rightElement,
  onClick,
  bg = "#DEEAF7",
}: BreadcrumbsProps) {
  return (
    <>
      <div
        className={`flex justify-between items-center ${
          title ? "mb-6" : "mb-0"
        }`}
      >
        <div className="flex items-center">
          <button
            type="button"
            onClick={onClick}
            className={`h-[40px] w-[40px] bg-[${bg}] rounded-[8px] flex items-center justify-center`}
          >
            <ChevronLeft className="h-[24px] w-[24px] text-[#666666]" />
          </button>
          <span className="text-[#1F1F1F] text-[20px] font-semibold ml-2">
            {title}
          </span>
        </div>
        <div>{rightElement}</div>
      </div>
    </>
  );
}
